import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { validate } from "../../helper/losDataHelper";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const TakeOverDmsDetails = ({ takeOverDmsDetails }) => {

    const takeOverDmsDetailsColumns = [
      {
        field: "dmsDetailsId",
        headerName: "DMS Details ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "performerId",
        headerName: "Performer ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "performerRole",
        headerName: "Performer Role",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "labelId",
        headerName: "Label ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "label",
        headerName: "Label",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "stateId",
        headerName: "State ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "state",
        headerName: "State",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "checklistId",
        headerName: "Checklist ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "active",
        headerName: "Active",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
    ];

        return(
            <AccordianContainer
            id="accord"
            title="TakeOver DMS Details"
            initialOpen={false}
          >
            <Box sx={{ marginTop: "-0.5%" }}>
            <CustomDataGrid
              noDataMessage="No Data"
              rows={ validate(takeOverDmsDetails) ?
                takeOverDmsDetails.map((item, index) => ({
                  id: index + 1,
                  ...item,
                })) : []}
              columns={takeOverDmsDetailsColumns}
              pageSize={15}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              gridHeight={305}
              getRowId={(row) => row.dmsDetailsId}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
            />
            </Box>
            </AccordianContainer>
        );

}

export default TakeOverDmsDetails;